<script>
import draggable from "vuedraggable";
import LegoTooltip from "@/components/Lego/LegoTooltip.vue";
import CardInColumn from "@/components/Lego/CardInColumn.vue";
import CreateCard from "@/components/Lego/CreateCard.vue";
import CreatorColumns from "@/components/Lego/CreatorColumns.vue";
import LoadMoreColumnsBtn from "@/components/Lego/LoadMoreColumnsBtn.vue";
import LegoProgressBar from "@/components/Lego/LegoProgressBar.vue";
import LoadMoreTaskInColumnBtn from "./LoadMoreTaskInColumnBtn.vue";
export default {
  components: {
    draggable,
    LegoTooltip,
    CardInColumn,
    CreateCard,
    CreatorColumns,
    LegoProgressBar,
    LoadMoreColumnsBtn,
    LoadMoreTaskInColumnBtn,
  },
  data() {
    return {
      sizesBoards: [600, 700, 300, 200, 500],
      isSkeleton: true,
    };
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    board() {
      return this.$store.state.lego.board;
    },
    columns() {
      // console.log(this.board.columns);

      if (this.board.columns) {
        this.isSkeleton = false;
        return this.board.columns;
      } else {
        return [];
      }
    },
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
    hasMoreColumns() {
      return this.$store.state.lego.hasMoreColumns;
    },
    loadingColumns() {
      return this.$store.state.lego.loadingColumns;
    },
    // Obtener el estado de carga de tareas para una columna específica
    tasksLoading() {
      return (columnId) =>
        this.$store.getters["lego/getTasksLoading"](columnId);
    },
    // Obtener el estado de paginación de tareas para una columna específica
    tasksPagination() {
      return (columnId) =>
        this.$store.getters["lego/getTasksPagination"](columnId);
    },
  },
  methods: {
    async loadMoreTasks(columnId) {
      const { pageNumber, pageSize, totalTasks } =
        this.tasksPagination(columnId);
      if (!this.tasksLoading(columnId) && pageNumber * pageSize < totalTasks) {
        await this.$store.dispatch("lego/loadMoreTasksInColumn", {
          boardId: this.board.id,
          columnId,
          personaId: this.userLoggedIn.id,
          pageNumberTasks: pageNumber + 1,
          pageSizeTasks: pageSize,
          collaboratorRoleLevel: this.roleLevel,
        });
      }
    },

    async loadMoreColumns() {
      await this.$store.dispatch("lego/loadMoreColumns");
    },
    createColumn(column) {
      // Seria bueno agregar un loader congelando la vista hasta que se cree la columna.
      column.LegoBoardId = this.board.id;
      console.log(column);
      this.$store.dispatch("lego/addColumn", column);
    },
    setTitle(ev, column) {
      const title = ev.target.value.trim();
      if (!title) return;
      this.$store.dispatch("lego/setItemInColumn", {
        columnId: column.id,
        obj: { title },
      });
      ev.target.blur();
    },
    setColor(ev, column) {
      const color = ev.target.value.trim();
      if (!color) return;
      this.$store.dispatch("lego/setItemInColumn", {
        columnId: column.id,
        obj: { color },
      });
    },
    onEndColumn(ev) {
      const { oldIndex, newIndex } = ev;
      let newColumns = [...this.columns]; // Clona la lista para evitar mutaciones directas

      console.log("oldIndex", oldIndex, "newIndex", newIndex);

      const movedItem = newColumns.splice(oldIndex, 1)[0];
      newColumns.splice(newIndex, 0, movedItem);
      this.$store.dispatch("lego/setColumns", newColumns);
    },
    deleteColumn(column) {
      this.$store.dispatch("lego/deleteColumn", column);
    },
    createCard(card, column) {
      card.LegoColumnId = column.id;
      this.$store.dispatch("lego/addCard", card);
    },
    inputCardDraggable(cards, columnId) {
      console.log("cards", cards);

      this.$store.dispatch("lego/moveCard", { cards, columnId });
    },
  },
};
</script>

<template>
  <div class="board">
    <draggable
      class="wrapper-columns"
      :group="{ name: 'columns' }"
      animation="300"
      :columns="columns"
      @end="onEndColumn"
      handle=".drag-handle"
    >
      <div
        :style="{ boxShadow: '0 4px 4px .1px var(--lego-shadow)' }"
        v-show="!isSkeleton || columns.length"
        v-for="column in columns"
        :key="column.id"
        :id="column.id"
      >
        <div
          :style="{ boxShadow: 'inset 0 4px 0 0' + column.color }"
          class="column drag-handle"
        >
          <header>
            <div class="d-flex justify-content-between align-items-center">
              <div class="tasks-indicator">
                <span v-if="column.cards.length && column.totalTasks">
                  {{ column.cards.length }} de {{ column.totalTasks }}
                  {{ column.totalTasks === 1 ? "tarea" : "tareas" }}
                </span>
                <span v-else> </span>
              </div>
              <!-- * control column -->
              <LegoTooltip position="bottom">
                <div class="wrapper-color">
                  <label :for="column.id + 'color'">
                    <span>Color</span>
                  </label>
                  <input
                    :id="column.id + 'color'"
                    class="color"
                    type="color"
                    :value="column.color"
                    @blur="setColor($event, column)"
                  />
                </div>
                <span class="text-lego-danger" @click="deleteColumn(column)"
                  >Eliminar columna</span
                >
              </LegoTooltip>
            </div>
            <input
              class="column-title"
              type="text"
              :value="column.title"
              @keydown.enter="setTitle($event, column)"
              @blur="setTitle($event, column)"
            />
          </header>
          <!-- progreso de columna -->
          <LegoProgressBar
            :list="column.cards"
            position="left"
            size="sm"
            mode="cards"
          />
          <CreateCard
            @createCard="createCard($event, column)"
            v-if="roleLevel < 3"
          />
          <draggable
            class="wrapper-tasks"
            ghost-class="bg-blue-200"
            @input="inputCardDraggable($event, column.id)"
            :value="column.cards"
            :group="{ name: 'cards' }"
            animation="300"
          >
            <CardInColumn
              v-for="card in column.cards"
              :key="card.id"
              :card="card"
              :id="card.id"
            />
          </draggable>

          <div v-show="column.cards.length >= 3" class="tasks-indicator">
            {{ column.cards.length }} de {{ column.totalTasks }}
            {{ column.totalTasks === 1 ? "tarea" : "tareas" }}
          </div>

          <!-- cargar mas tareas -->
          <LoadMoreTaskInColumnBtn
            @loadMoreTasks="loadMoreTasks(column.id)"
            :loading="tasksLoading(column.id)"
            v-if="column.totalTasks > column.cards.length"
          />
        </div>
      </div>
      <b-skeleton
        v-show="isSkeleton"
        v-for="column in 5"
        :key="column"
        width="300px"
        :height="`${sizesBoards[column - 1]}px`"
      ></b-skeleton>
    </draggable>

    <!-- cargar mas columnas -->
    <LoadMoreColumnsBtn
      @loadMoreColumns="loadMoreColumns"
      :loading="loadingColumns"
      v-if="hasMoreColumns"
    />

    <CreatorColumns @createColumn="createColumn" v-if="roleLevel < 3" />
  </div>
</template>

<style scoped>
.tasks-indicator {
  opacity: 0.7;
}
.board {
  flex: 1;
  padding: 1rem;
  display: flex;
  overflow: auto;
  width: 100%;
  height: 100%;
  gap: 1rem;
}

.wrapper-columns {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.column {
  position: relative;
  padding: 1rem;
  width: 300px;
  border-radius: 3px;
  cursor: move;
  /* box-shadow: inset 0 4px 0 0 var(--lego-dbg); */
  background-color: var(--lego-bg);
  .dark & {
    background-color: var(--lego-oscuro);
  }
}

.column-title {
  background-color: transparent;
  letter-spacing: 0.25rem;
  border: 0;
  outline: none;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  color: white;
  padding: 0.5rem;
  border-radius: 3px;
}

.column-title:focus {
  background-color: var(--lego-light-hover);
  cursor: text;
}

.wrapper-tasks {
  /* border-top: 0.25rem solid; */
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.wrapper-color {
  padding: 0;
  position: relative;
}

.wrapper-color label {
  padding: 0.5rem 1rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.color {
  position: absolute;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  width: 0px;
  height: 0px;
  transform: translateY(-2px);
}
</style>
